import type { DiagnosticsEvent, DiagnosticsEventInput } from "@/lib/diagnostics/types";

let eventCounter = 0;

function nextDiagnosticsEventId(): string {
    eventCounter += 1;
    return `diag_${Date.now()}_${eventCounter}`;
}

export function normalizeDiagnosticsEvent(input: DiagnosticsEventInput): DiagnosticsEvent {
    return { id: nextDiagnosticsEventId(), ts: new Date().toISOString(), source: input.source, message: input.message, stack: input.stack ?? null, code: input.code ?? null, route: input.route ?? null, action: input.action ?? null, correlationId: input.correlationId ?? null, context: input.context ?? null };
}

export function errorToDiagnosticsFields(error: unknown): { message: string; stack: string | null; code: string | null; } {
    if (error instanceof Error) {
        const code = "code" in error && typeof (error as Error & { code?: unknown; }).code === "string" ? (error as Error & { code: string; }).code : null;
        return { message: error.message, stack: error.stack ?? null, code };
    }
    if (typeof error === "string") {
        return { message: error, stack: null, code: null };
    }
    try {
        return { message: JSON.stringify(error), stack: null, code: null };
    } catch {
        return { message: String(error), stack: null, code: null };
    }
}
